import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "form-field-floating lg reactive my-5" }
const _hoisted_2 = ["value"]
const _hoisted_3 = { class: "form-field-floating lg reactive my-5" }
const _hoisted_4 = ["value"]
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { style: {"text-align":"center"} }
const _hoisted_7 = ["src"]
const _hoisted_8 = {
  key: 1,
  class: "form-field-floating lg reactive my-5"
}
const _hoisted_9 = ["value"]

import { reactive, ref } from 'vue';
    
    import axios from 'axios';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'AdminCredentialsInfosModal',
  setup(__props, { expose: __expose }) {

    let admin: any = null;
    const isOpened = ref(false);
    const errorMessage = ref('');
    const loading = ref(false);
    const credentialsInfos = reactive({
        username: '',
        has_default_password: false,
        password: '',
        has_default_code_securite: false,
        mfa_security_key: '',
        mfa_enabled: 0,
        mfa_qr_code: ''
    });

    async function doFetchCredentialsInfos() {
        loading.value = true;
        errorMessage.value = '';
        try {
            const httpResponse = await axios.get(`/backoffice/admins/get_credentials_infos/${admin.id}`);
            credentialsInfos.username = httpResponse.data.username;
            credentialsInfos.has_default_password = httpResponse.data.has_default_password;
            credentialsInfos.password = httpResponse.data.password;
            credentialsInfos.has_default_code_securite = httpResponse.data.has_default_code_securite;
            credentialsInfos.mfa_security_key = httpResponse.data.mfa_security_key;
            credentialsInfos.mfa_enabled = httpResponse.data.mfa_enabled;
            credentialsInfos.mfa_qr_code = httpResponse.data.mfa_qr_code;
        } catch(error: any) {
            errorMessage.value = error.message;
            console.error(error);
        } finally {
            loading.value = false;
        }

        return null;
    }
    
    async function doResetPasswordAction() {
        loading.value = true;
        errorMessage.value = '';
        try {
            await axios.post(`/backoffice/admins/reset_password/${admin.id}`, {});
            await doFetchCredentialsInfos();
        } catch(error: any) {
            errorMessage.value = error.message;
            console.error(error);
        } finally {
            loading.value = false;
        }

        return null;
    }
    
    async function doEnableMFAAction() {
        loading.value = true;
        errorMessage.value = '';
        try {
            await axios.post(`/backoffice/admins/enable_mfa/${admin.id}`, {});
            await doFetchCredentialsInfos();
        } catch(error: any) {
            errorMessage.value = error.message;
            console.error(error);
        } finally {
            loading.value = false;
        }

        return null;
    }
    
    async function doDisableMFAAction() {
        loading.value = true;
        errorMessage.value = '';
        try {
            await axios.post(`/backoffice/admins/disable_mfa/${admin.id}`, {});
            await doFetchCredentialsInfos();
        } catch(error: any) {
            errorMessage.value = error.message;
            console.error(error);
        } finally {
            loading.value = false;
        }

        return null;
    }
    
    async function open(selectedAdmin: any) {
        admin = selectedAdmin;
        await doFetchCredentialsInfos();
        isOpened.value = true;
    }

    function close() {
        isOpened.value = false;
    }

    __expose({ open, close });

return (_ctx: any,_cache: any) => {
  const _component_custom_modal = _resolveComponent("custom-modal")!

  return (_openBlock(), _createBlock(_component_custom_modal, {
    show: isOpened.value,
    "onUpdate:show": _cache[1] || (_cache[1] = ($event: any) => ((isOpened).value = $event))
  }, {
    header: _withCtx(() => [...(_cache[2] || (_cache[2] = [
      _createElementVNode("h4", { class: "font-semibold" }, "Informations de connexion", -1)
    ]))]),
    footer: _withCtx(() => [
      (credentialsInfos.mfa_enabled == 1)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            class: "btn-ultra white2",
            style: {"justify-content":"center"},
            onClick: doDisableMFAAction
          }, "Réinitialiser la double authentification"))
        : _createCommentVNode("", true),
      (credentialsInfos.has_default_password == false)
        ? (_openBlock(), _createElementBlock("button", {
            key: 1,
            class: "btn-ultra white2",
            style: {"justify-content":"center"},
            onClick: doResetPasswordAction
          }, "Réinitialiser le mot de passe"))
        : _createCommentVNode("", true),
      _createElementVNode("button", {
        class: "btn-ultra white2",
        style: {"justify-content":"center"},
        onClick: _cache[0] || (_cache[0] = ($event: any) => (isOpened.value = false))
      }, "Fermer")
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("input", {
            type: "text",
            class: "form-input",
            value: credentialsInfos.username,
            name: "identifiant",
            id: "identifiant",
            placeholder: "",
            readonly: ""
          }, null, 8, _hoisted_2),
          _cache[3] || (_cache[3] = _createElementVNode("label", { for: "identifiant" }, "Identifiant", -1))
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("input", {
            type: "text",
            class: "form-input",
            value: credentialsInfos.password ?? '******',
            name: "password",
            id: "password",
            placeholder: "",
            readonly: ""
          }, null, 8, _hoisted_4),
          _cache[4] || (_cache[4] = _createElementVNode("label", { for: "password" }, "Mot de passe", -1))
        ]),
        (credentialsInfos.mfa_qr_code)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _cache[5] || (_cache[5] = _createElementVNode("div", null, "QR Code MFA", -1)),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("img", {
                  src: 'data:image/png;base64,' + credentialsInfos.mfa_qr_code,
                  height: "200px"
                }, null, 8, _hoisted_7)
              ])
            ]))
          : _createCommentVNode("", true),
        (credentialsInfos.mfa_security_key)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createElementVNode("input", {
                type: "text",
                class: "form-input",
                value: credentialsInfos.mfa_security_key,
                name: "mfa_security_key",
                id: "mfa_security_key",
                placeholder: "",
                readonly: ""
              }, null, 8, _hoisted_9),
              _cache[6] || (_cache[6] = _createElementVNode("label", { for: "mfa_security_key" }, "Clé de sécurité MFA", -1))
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["show"]))
}
}

})